module.exports = __webpack_public_path__ + "static/media/Approve-icon-disabled.8fecebb9.svg";